import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { deploymentPreconditionRelayResource } from '@jira/router-resources__software-deployments/src/deploymentPreconditionRelayResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareDeploymentsNextGenRoute } from '@jira/router-routes__software-deployments-routes/src/softwareDeploymentsNextGenRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { softwareDeploymentsPageEntrypoint } from './common/deployments.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareDeploymentsNextGenRouteEntry: Route = createEntry(
	softwareDeploymentsNextGenRoute,
	() => ({
		group: 'software',
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			deploymentPreconditionRelayResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
		],

		entryPoint: () =>
			isDevopsFeatureDisabledInFedRamp()
				? notFoundPageEntrypoint
				: softwareDeploymentsPageEntrypoint,

		meta: {
			reporting: {
				id: 'software-deployments',
				packageName: camelCase('software-deployments'),
				teamName: 'fusion-solaris',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
